/** A domain as a list of companies compares it: trimmed, lowercased, no `www.`. */
export function candidateDomainKey(domain: string): string {
  return domain
    .trim()
    .toLowerCase()
    .replace(/^www\./, '')
}

/** True when a list already holds a company with the same domain. */
export function hasCandidateDomain(domain: string, domains: readonly string[]): boolean {
  const key = candidateDomainKey(domain)
  return domains.some((kept) => candidateDomainKey(kept) === key)
}
